import { FAST_API_URL } from "@/shared/config/player";
import { VideoSegmentsData } from "@/features/player/api/types";

const prefix = "/segments";

export const getBuildFullWithoutPauseApi = async ({
    mediaId,
    lang,
}: {
    mediaId: string;
    lang: string;
}): Promise<VideoSegmentsData> => {
    const response = await fetch(
        `${FAST_API_URL}${prefix}/build_full_without_pauses_for_media?media=${mediaId}&lang=${lang}`,
    );
    if (!response.ok) {
        throw new Error("cant get all data for Editing");
    }
    return await response.json();
};
